import React from "react";

// @material-ui/icons
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Radio from '@material-ui/core/Radio';
import FormControlLabel from "@material-ui/core/FormControlLabel";

// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import CustomInput from "../../../components/CustomInput/CustomInput.jsx";

import customCheckboxRadioSwitch from "../../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const style = {
	checkBoxLabelError: {
		background: "#ff0000"
	},
	infoText: {
		fontWeight: "300",
		margin: "10px 0 30px",
		textAlign: "center"
	},
	inputAdornmentIcon: {
		color: "#555"
	},
	inputAdornment: {
		position: "relative"
	},
	...customCheckboxRadioSwitch
};

class Step5 extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			selected: "",
			selectedState: "",
			description: "",
			laserName: "",
			laserNameState: ""
		};
		this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
	}

	renderDescription(){
		this.setState({
			description: [
				"Name of the laser source: ",
				this.state.laserName
			].join(' ')
		})
	}

	verifyLength(value, length) {
		if (value.length >= length) {
			return true;
		}
		return false;
	}

	change(event, stateName, type = null, stateNameEqualTo = -1){

		switch (type) {
			case "checkbox":
				if (event.target.checked) {
					this.setState({ [stateName + "State"]: "success" }, () => {
						if (!this.isCustomChoice()) {
							this.setState({ laserNameState: "" });
						}
					});
				} else {
					this.setState({ [stateName + "State"]: "error" });
				}
				break;
			case "length":
				if (this.verifyLength(event.target.value, stateNameEqualTo)) {
					this.setState({ [stateName + "State"]: "success" });
				} else {
				 this.setState({ [stateName + "State"]: "error" });
				}
				break;
			default:
				break;
		}

		this.setState({ [stateName]: event.target.value }, () => {
			this.renderDescription();
		});
	}

	handleChangeEnabled(event) {
		this.change(event, "selected")
	}

	sendState() {
		return this.state;
	}

	isValidated() {
		if (
			this.state.selectedState === "success" &&
			(this.state.laserNameState === "success" || !this.isCustomChoice())
		){
			return true;
		} else {

			if (this.state.selectedState !== "success"){
				this.setState({ selectedState: "error" });
			}

			if (this.state.laserNameState !== "success" && this.isCustomChoice()){
				this.setState({ laserNameState: "error" });
			}

		}
		return false;
	}

	isError(){
		return this.state.selectedState === "error"
	}

	isCustomChoice(){
		return (this.state.selected === "Your requested laser source" ||
						this.state.selected === "Integration of an existing laser source")
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
			<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={12}>
					<h4 className={classes.infoText}>
						Select your laser source, if any.
					</h4>
				</GridItem>
			</GridContainer>
			<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={4}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Selection by 3D-Micromac"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Selection by 3D-Micromac"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Selection by 3D-Micromac"
					/>
				</div>
				</GridItem>
				<GridItem xs={4}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Your requested laser source"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Your requested laser source"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Your requested laser source"
					/>
				</div>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={4}>
				<div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
					<FormControlLabel
						control={
							<Radio
								checked={this.state.selected === "Integration of an existing laser source"}
								onChange={event =>
									this.change(event, "selected", "checkbox")
								}
								value="Integration of an existing laser source"
								name="radio button enabled"
								icon={<FiberManualRecord className={classes.radioUnchecked + " " + (this.isError() ? classes.checkBoxLabelError:"")}/>}
								checkedIcon={<FiberManualRecord className={classes.radioChecked}/>}
								classes={{
									checked: classes.radio
								}}
							/>
						}
						classes={{label: classes.label}}
						label="Integration of an existing laser source"
					/>
				</div>
				</GridItem>
				<GridItem xs={4}>
				</GridItem>
				</GridContainer>
				<GridContainer justify="center" alignItems="center" direction="row">
				<GridItem xs={8}>
					<CustomInput
						success={this.state.laserNameState === "success"}
						error={this.state.laserNameState === "error"}
						labelText="Name of the laser source"
						id="custom-features"
						formControlProps={{
							fullWidth: true
						}}
						inputProps={{
							onChange: event => this.change(event, "laserName", "length", 0)
						}}
					/>
				</GridItem>
			</GridContainer>
			</div>
		);
	}
}

export default withStyles(style)(Step5);



// WEBPACK FOOTER //
// ./src/views/ConfiguratorEN/ConfiguratorSteps/Step5.jsx